import { useNavigate } from "react-router-dom";
import ArrowLeftIcon from "../../assets/icons/pagination/arrowleftIcon";
import ArrowRightIcon from "../../assets/icons/pagination/arrowrightIcon";

const Pagination = ({ pagination, totalPages, path, filters = "" }) => {
  const navigate = useNavigate();

  const handlePageChange = (value) => {
    if (value === "next") {
      navigate(`${path}?page=${pagination + 1}${filters}`);
    } else if (value === "prev") {
      navigate(`${path}?page=${pagination - 1}${filters}`);
    } else {
      navigate(`${path}?page=${value}${filters}`);
    }
  };

  const getPageNumbers = () => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    } else if (pagination <= 2) {
      return [1, 2, 3, 4, 5];
    } else if (pagination >= totalPages - 1) {
      return [
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }
    const startPage = pagination - 2;
    const endPage = pagination + 2;
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  const pageNumbers = getPageNumbers();

  return (
    <section className="flex justify-end mt-4">
      <div>
        {pagination && totalPages > 0 && (
          <div className="flex items-center gap-3">
            <span className="px-3 py-1 mx-3">
              <span className="text-primary font-fw_700 mx-1">
                {pagination}
              </span>
              /<span className="font-fw_700 mx-1">{totalPages}</span>
            </span>

            <button
              disabled={pagination === 1 ? true : false}
              onClick={() => {
                handlePageChange("prev");
              }}
              type="button"
              className={`border-none bg-secondary p-2 rounded-md cursor-pointer ${
                pagination <= 1 ? "opacity-50" : ""
              }`}
            >
              <ArrowLeftIcon fill="#ffff" width={12} height={12} />
            </button>

            {pageNumbers.map((pageNumber) => (
              <button
                onClick={() => {
                  handlePageChange(pageNumber);
                }}
                key={pageNumber}
                className={`border-0 fs_16 cursor-pointer rounded-md ${
                  pagination === pageNumber
                    ? "bg-primary text-white "
                    : "bg-transparent color_030304"
                }   fw_600 fs_16 p-1 px-3`}
                type="button"
              >
                {pageNumber ?? pageNumber}
              </button>
            ))}

            <button
              disabled={pagination === totalPages ? true : false}
              onClick={() => {
                handlePageChange("next");
              }}
              type="button"
              className={`border-none bg-secondary p-2 rounded-md cursor-pointer disabled:opacity-50 ${
                pagination >= totalPages ? "opacity-50" : ""
              }`}
            >
              <ArrowRightIcon fill="#ffff" width={12} height={12} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Pagination;
